module.exports = {
    "group":"group"
}


/** WEBPACK FOOTER **
 ** ./src/styles/CheckboxesGroupTemplate-style.js
 **/